import React, { Component } from 'react';

import Header from "../Header/Header"
import Footer from "../Footer/Footer"
import Body from "../Body/Body";


export default class App extends Component {
  constructor() {
    super();
    this.setPage = this.setPage.bind(this);
    this.state = {
      pageStyle: "form"
    }
  }
  setPage(pageStyle) {
    this.setState({
      pageStyle: pageStyle
    })
  }

  render() {
    return (
      <div className="App">
        <Header />

        <div className="App-bg">
          {(() => {
            switch (this.state.pageStyle) {
              case "form":
                return (
                  <div>
                    <Body setPage={this.setPage} />
                  </div>
                );

              case "isExsits":
                return (
                  <div className="headline">
                    <div className="text-center">
                      מותר להשתתף רק פעם אחת
                  </div>
                  </div>
                );

              case "thankyou":
                return (
                  <div className="headline">
                    <div className="text-center">
                      תודה על השתתפותכם
                   </div>
                  </div>
                );
            }
          })()}
        </div>



        <Footer />
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/Components/App/App.jsx